export default {
  palette: {
    primary: {
      main: '#0E4A76',
    },
    secondary: {
      main: '#0C6532',
    },
    background: {
      default: '#f9f9f9',
    },
  },
  drawer: {
    width: 240,
  },
  overrides: {
    MuiCollapse: {
      entered: {
        height: 'auto',
        '.overflowVisible > &': {
          overflow: 'visible',
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/styles/theme.js